module.exports = __webpack_public_path__ + "r.7901d924.png";